// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"412":"d5cfc9c7","739":"b2fd0005"}[chunkId] + ".chunk.js";
};